import {merge} from "lodash";
import partnerMessages from "@i18n_messages_hu"

export default merge({}, partnerMessages);